import { useConfirmationDialog } from ".";

export function useDeleteConfirmationDialog() {
  const openConfirmationDialog = useConfirmationDialog();
  return (message: string, onConfirmation: () => void) =>
    openConfirmationDialog("Delete Confirmation", message, onConfirmation);
}
